import React from "react";
import {setSession,resetSession} from '../../../utils/websockets_utils/session';
import { ActionTypes } from "../../action-type";
import  secureLocalStorage  from  "react-secure-storage";


export const TopicProvider = (action,data) => async(dispatch) =>{
    secureLocalStorage.setItem("topic",data)
    var _topic = secureLocalStorage.getItem("topic")
    dispatch({
        type:ActionTypes.TOPICS,
        payload:{action,data}
    })
    // if(action && data){
    //     resetSession();
    //     setSession(action,data);
    //     dispatch({
    //         type:ActionTypes.TOPICS,
    //         payload:{action:action,data:data}
    //     })
    // }
    // else if (_action && _data){
    //     dispatch({
    //         type:ActionTypes.TOPICS,
    //         payload:{action:_action,data:_data}
    //     })
    // }
  
};